export default "__VITE_ASSET__01a2a812__"